<br>

<div class="row">
	<div class="col-md-6">
		<form
			*ngIf="filterParams.isBilling || filterParams.isDomainBilling"
			class="form-inline"
		>
			<div class="form-group">
				{{ 'adminstat.billing.billing.Currency type' | translate }}
			</div>

			<select
				class="form-control"
				(change)="getReferers()"
				[(ngModel)]="currencyType"
				[ngModelOptions]="{standalone: true}"
			>
				<option
					*ngFor="let _currency of ['all'].concat(currencyList)"
					value="{{ _currency }}"
					[selected]="_currency == currencyType"
				>
					{{ _currency }}
				</option>
			</select>
		</form>
	</div>
	
	<div class="col-md-6">
		<form class="form-inline">
			<div class="form-group">
				{{ 'adminstat.filterForm.refererShowType' | translate }}
			</div>

			<select
				class="form-control"
				(change)="getReferers()"
				[(ngModel)]="refererType"
				[ngModelOptions]="{standalone: true}"
			>
				<option
					*ngFor="let refType of ['first', 'created', 'last', 'paid']"
					value="{{ refType }}"
					[selected]="refererType == refType"
				>
					{{ 'adminstat.filterForm.' + refType | translate }}
				</option>
			</select>
		</form>	
	</div>
</div>

<br>

<div *ngIf="refLoader" class="loader">
	<img src="/img/loader.svg" class="img-responsive center-block">
</div>


<reg-day-refs
	*ngIf="!refLoader && stats && filterParams.isRegDay"
	[refs]="stats.refs"
	[filterParams]="filterParams"
	[currentUrl]="currentUrl"
></reg-day-refs>

<billing-refs
	*ngIf="!refLoader && stats && filterParams.isBilling"
	[refs]="stats.refs"
	[filterParams]="filterParams"
	[currentUrl]="currentUrl"
></billing-refs>

<domain-billing-refs
	*ngIf="!refLoader && stats && filterParams.isDomainBilling"
	[refs]="stats.refs"
	[filterParams]="filterParams"
	[currentUrl]="currentUrl"
></domain-billing-refs>
